export default __webpack_public_path__ + "static/usta-admin-logo-8622e7cb62b5c06d82bef75563b55c88.svg";